import script from "./DeviceDetailsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeviceDetailsTable.vue?vue&type=script&setup=true&lang=ts"

import "./DeviceDetailsTable.vue?vue&type=style&index=0&id=4b425100&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b425100"]])

export default __exports__